// Angular imports
import { Input } from '@angular/core';

// Component imports
import { MPBaseChartComponent } from './mp-base-chart.component';

// Service imports
import { ScreenService } from '../_services/shared-services/screen.service';
import { ContextManagerService } from '../_services/data-services/context-manager.service';
import { HelperService } from '../_services/shared-services/helper.service';
import { UserService } from '../_services/data-services/user.service';

export abstract class MPBasePieChartComponent extends MPBaseChartComponent {
    isSmallScreen = false;

    @Input() pieGroup = 'pieGroup';

    diameter = 0.6;
    fontSize = 12;
    legendCount: number;

    constructor(
        protected readonly screenService: ScreenService,
        protected readonly contextManagerService: ContextManagerService,
        protected readonly helperService: HelperService,
        protected readonly userService: UserService
    ) {
        super(screenService, contextManagerService, helperService, userService);
    }

    setChartSize() {
        super.setChartSize();
        if (this.widgetMode) {
            this.diameter = 0.5;
        }
        if (this.isSmallScreen && this.legendCount > 8) {
            this.diameter = this.widgetMode ? 0.3 : 0.35;
        } else if (this.isSmallScreen) {
            this.diameter = this.widgetMode ? 0.4 : 0.5;
        }

        if (this.isSmallScreen) {
            this.fontSize = 10;
            if (this.legendCount > 8) {
                this.fontSize = 9;
            }
        } else {
            if (window.screen.width > 1366) {
                this.fontSize = 12;
                if (this.legendCount > 8) {
                    this.fontSize = 11;
                }
            } else {
                this.fontSize = 10;
            }
        }
    }
}
